import React from "react";
import { string, oneOf } from "prop-types";
import Button from "../Button";
import { classes } from "../utils/classes";

const ButtonTheme = ({ className, styleType, ...props }) => (
	<Button isTheme className={classes(`button-theme-${styleType}`, className)} {...props} />
);

ButtonTheme.propTypes = {
	styleType: oneOf([
		"submit",
		"modal-submit",
		"modal-submit-active",
		"print-invoice",
		"place-order",
		"topbar",
	]).isRequired,
	className: string,
};

const ButtonThemeLink = props => <ButtonTheme Tag="a" {...props} />;

ButtonTheme.Link = ButtonThemeLink;

export default ButtonTheme;
